
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Punetomahabaleshwar() {



  const cardData =
  {
    keyword: ' Pune to Mahabaleshwar Cab',
    heading: 'SHREE Tours & Travels: Pune to Mahabaleshwar Cab',
    headingDescription: 'SHREE Tours & Travels provides a reliable Pune to Mahabaleshwar Cab service, ensuring a comfortable and scenic journey to the famous hill station. Whether you are planning a weekend getaway, a family trip, or a romantic retreat, our well-maintained Cabs and professional drivers make your travel hassle-free. Enjoy the breathtaking landscapes and cool climate of Mahabaleshwar with our flexible booking options and affordable fares. Choose SHREE Tours & Travels for a safe and enjoyable Pune to Mahabaleshwar ride.',

    top: 'Top Places to Visit in Mahabaleshwar with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Venna Lake",
        "description": "Venna Lake is one of Mahabaleshwar's most picturesque attractions, offering visitors the opportunity to enjoy boating, horse riding and scenic strolls along its banks. Surrounded by lush greenery, this serene lake is perfect for relaxation and photography. The nearby food stalls serve delicious local snacks, making it an ideal spot for families and couples looking for a refreshing escape."
    },
    {
        "title": "Elephant’s Head Point",
        "description": "One of Mahabaleshwar's most iconic viewpoints, Elephant’s Head Point offers breathtaking panoramic views of the Sahyadri mountains and deep valleys. The rock formation here resembles an elephant’s head and trunk, making it a unique natural wonder. The cool breeze and spectacular sunrise and sunset views make it a must-visit for nature lovers and photographers."
    },
    {
        "title": "Arthur’s Seat",
        "description": "Arthur’s Seat, also known as the 'Queen of all Points,' is famous for its mesmerizing views of the deep valleys and the Savitri River. Located at an elevation of 1,470 meters, this viewpoint provides an incredible contrast between the lush green forests and the barren landscapes of the Konkan region. The natural rock formation here is known for its ability to bounce back light objects thrown into the valley."
    },
    {
        "title": "Pratapgad Fort",
        "description": "A historical marvel, Pratapgad Fort is a significant site associated with Chhatrapati Shivaji Maharaj’s victory over Afzal Khan. The fort features well-preserved structures, including watchtowers, temples and a statue of Shivaji Maharaj. Adventure seekers can trek up the fort to soak in breathtaking views of the surrounding mountains, while history enthusiasts can explore its rich past and strategic importance."
    },
    {
        "title": "Mapro Garden",
        "description": "A paradise for strawberry lovers, Mapro Garden is a famous attraction in Mahabaleshwar known for its fresh strawberries, jams, syrups and delectable ice creams. Visitors can witness the strawberry farming process, sample fresh fruit-based products and enjoy delicious strawberry cream. The lush green ambiance and open-air café make it a great spot for families and food enthusiasts."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Lingmala Waterfall is a spectacular natural attraction that cascades from a height of 600 feet, offering a breathtaking sight, especially during the monsoon season. The falls have two sections – a smaller one for safe dipping and a larger one for stunning panoramic views. Surrounded by lush forests, this waterfall is an ideal place for nature lovers and adventure seekers."
    },
    {
        "title": "Wilson Point",
        "description": "Wilson Point, the highest point in Mahabaleshwar, is the best place to witness mesmerizing sunrises. Located at an altitude of 1,439 meters, it offers a 360-degree view of the surrounding hills and valleys. Visitors can enjoy the tranquil atmosphere and watch the sky transform with hues of orange and pink, making it a must-visit for photographers and early risers."
    },
    {
        "title": "Panchgani",
        "description": "A charming hill station near Mahabaleshwar, Panchgani is known for its breathtaking viewpoints, strawberry farms and pleasant climate. Table Land, one of the largest volcanic plateau formations in Asia, is a major attraction here. Visitors can enjoy horse riding, paragliding and panoramic views of the Krishna River Valley, making it a perfect getaway for adventure seekers and nature lovers."
    },
    {
        "title": "Mahabaleshwar Temple",
        "description": "The Mahabaleshwar Temple, dedicated to Lord Shiva, is an ancient temple known for its religious significance and stunning Hemadpanti architecture. The temple houses the sacred Shiva Linga and is an important pilgrimage site for devotees. The serene surroundings and spiritual ambiance make it a peaceful place to seek blessings and experience divine tranquility."
    },
    {
        "title": "Connaught Peak",
        "description": "Connaught Peak is a lesser-known but equally stunning viewpoint in Mahabaleshwar. Named after the Duke of Connaught, this spot offers spectacular views of Venna Lake, Krishna Valley and Pratapgad Fort. It’s a great location for trekking, meditation and enjoying the untouched beauty of nature."
    }
],  
    
            
"services": [
    {
      "name": "Pune to Mahabaleshwar Taxi",
      "description": "Travel comfortably with SHREE Tours & Travels by booking a taxi from Pune to Mahabaleshwar. Our well-maintained fleet ensures a smooth and scenic journey with professional drivers who will make your trip comfortable and hassle-free. Enjoy the lush landscapes along the way."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Service",
      "description": "Looking for a reliable Cab service from Pune to Mahabaleshwar? We offer affordable one-way and round-trip Cab options with experienced drivers. Whether you’re traveling for a quick getaway or a leisurely tour, we provide comfort and safety throughout your journey."
    },
    {
      "name": "Pune to Mahabaleshwar One-Way Taxi",
      "description": "Need a one-way taxi from Pune to Mahabaleshwar? Book with SHREE Tours & Travels for a convenient and cost-effective ride. Enjoy the freedom of flexible schedules with no hidden charges and a hassle-free experience."
    },
    {
      "name": "Pune to Mahabaleshwar Round Trip Cab",
      "description": "Planning a round-trip to Mahabaleshwar? Our round-trip Cab service offers flexibility to choose your return time, whether it’s the same day or after a few days. Enjoy a seamless and well-maintained ride both ways with professional drivers."
    },
    {
      "name": "Affordable Pune to Mahabaleshwar Cab",
      "description": "Get affordable Cab services from Pune to Mahabaleshwar without compromising on comfort. Enjoy a smooth and pleasant ride at competitive rates, ensuring you have a relaxing trip to Mahabaleshwar while staying within budget."
    },
    {
      "name": "Private Taxi for Mahabaleshwar from Pune",
      "description": "Book a private taxi from Pune to Mahabaleshwar for a personalized travel experience. Enjoy the privacy and comfort of your own vehicle, allowing you to travel at your own pace, with our experienced drivers ensuring a safe and enjoyable journey."
    },
    {
      "name": "Mahabaleshwar Tour from Pune by Cab",
      "description": "Planning a Mahabaleshwar tour from Pune? Our Cab service ensures you have a comfortable and convenient trip with an experienced driver. Enjoy sightseeing options and explore Mahabaleshwar’s beauty with our professional drivers guiding the way."
    },
    {
      "name": "Mahabaleshwar Cab Hire",
      "description": "Hire a Cab from Pune to Mahabaleshwar with SHREE Tours & Travels. Choose from a variety of vehicles like sedans, SUVs and luxury cars for a comfortable and reliable ride to this hill station. We provide affordable options to meet your needs."
    },
    {
      "name": "Group Travel from Pune to Mahabaleshwar",
      "description": "Traveling with a group? We provide spacious vehicles for group travel to Mahabaleshwar, ensuring comfort and safety for all. Whether it’s a family vacation or a corporate retreat, our well-maintained fleet can accommodate large groups with ease."
    },
    {
      "name": "Book Pune to Mahabaleshwar Car",
      "description": "Rent a car for your Pune to Mahabaleshwar journey with SHREE Tours & Travels. Choose from a variety of vehicles like sedans, SUVs, or tempo travelers for group trips. Enjoy a smooth and hassle-free ride to your destination."
    },
    {
      "name": "Mahabaleshwar Cab Booking from Pune",
      "description": "Easily book a Cab from Pune to Mahabaleshwar with our reliable online booking service. Enjoy timely pickups and professional service, along with the convenience of booking a comfortable ride at affordable rates."
    },
    {
      "name": "Luxury Cab for Pune to Mahabaleshwar",
      "description": "Experience a premium travel experience with our luxury Cab service from Pune to Mahabaleshwar. Choose high-end vehicles like Innova Crysta or Mercedes and enjoy a lavish ride with all the comforts, perfect for those seeking a luxurious journey."
    },
    {
      "name": "Weekend Trip Pune to Mahabaleshwar",
      "description": "Escape to the serene hill station of Mahabaleshwar for a weekend trip from Pune. Our weekend trip service offers convenient pick-up times and flexible schedules, making it the perfect getaway. Enjoy breathtaking views and a relaxing experience."
    },
    {
      "name": "Mahabaleshwar Sightseeing Tour by Cab",
      "description": "Explore Mahabaleshwar with our sightseeing tour by Cab. Visit iconic attractions like the Mahabaleshwar Temple, Arthur’s Seat and more, with an experienced driver guiding you through the scenic spots. Make the most of your trip with our convenient Cab service."
    },
    {
      "name": "Pune to Mahabaleshwar Comfort Taxi",
      "description": "Book a comfortable taxi for your Pune to Mahabaleshwar journey. Our well-maintained fleet and professional chauffeurs guarantee a smooth and relaxing ride, ensuring that you can unwind and enjoy the scenic drive through the hills."
    },
    {
      "name": "Mahabaleshwar Temple Visit by Cab",
      "description": "Take a temple tour to Mahabaleshwar with our comfortable Cab service. Visit the famous Mahabaleshwar Temple and other religious sites in the region with an experienced driver who ensures a smooth, convenient and peaceful visit to these sacred places."
    }
  ],

  "tableData": [
    ["- Pune to Mahabaleshwar Taxi", "- Pune to Mahabaleshwar Cab Service"],
    ["- Pune to Mahabaleshwar One-Way Taxi", "- Pune to Mahabaleshwar Round Trip Cab"],
    ["- Affordable Pune to Mahabaleshwar Cab", "- Private Taxi for Mahabaleshwar from Pune"],
    ["- Mahabaleshwar Tour from Pune by Cab", "- Mahabaleshwar Cab Hire"],
    ["- Group Travel from Pune to Mahabaleshwar", "- Book Pune to Mahabaleshwar Car"],
    ["- Mahabaleshwar Cab Booking from Pune", "- Luxury Cab for Pune to Mahabaleshwar"],
    ["- Weekend Trip Pune to Mahabaleshwar", "- Mahabaleshwar Sightseeing Tour by Cab"],
    ["- Pune to Mahabaleshwar Comfort Taxi", "- Mahabaleshwar Temple Visit by Cab"]
  ],

  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable Journey",
      "WhyChoosedescription": "Our Pune to Mahabaleshwar Cabs are designed for a smooth and comfortable journey. With spacious interiors, comfortable seating and air-conditioning, you can relax and enjoy the scenic drive. Whether you're traveling for leisure or a quick getaway, our vehicles ensure a pleasant experience throughout the trip."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our drivers are experienced and well-versed with the routes from Pune to Mahabaleshwar. They know the roads well and ensure a safe, timely and smooth journey. With their professionalism and focus on safety, you can relax and enjoy the ride while we handle the driving."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer affordable pricing for your Pune to Mahabaleshwar Cab ride. With transparent pricing and no hidden charges, you can enjoy great value without compromising on quality. Whether you're booking a one-way trip or a round trip, our competitive rates ensure a budget-friendly option for your travel."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles are regularly maintained and thoroughly inspected for safety and reliability. From clean interiors to smooth performance, we ensure that your ride is comfortable, safe and pleasant. Our well-maintained fleet guarantees you a worry-free journey to Mahabaleshwar."
    },
    {
      "WhyChooseheading": "Flexible Rental Options",
      "WhyChoosedescription": "We offer flexible rental packages for your Pune to Mahabaleshwar trip. Whether you need a Cab for a few hours, a full day, or multiple days, we can tailor the rental to fit your needs. Our customizable options allow you to plan your journey just the way you want."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a Cab for your Pune to Mahabaleshwar trip is easy with SHREE Tours & Travels. You can book online through our user-friendly platform or contact our customer service for personalized assistance. Whether you're planning ahead or need a last-minute ride, we make booking simple and stress-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Pune to Mahabaleshwar Cab needs. Whether you need to travel early in the morning or late at night, we are always ready to serve you. Our around-the-clock service ensures that you have reliable transportation whenever you need it."
    },
    {
      "WhyChooseheading": "Local Insights",
      "WhyChoosedescription": "Our drivers are not only experts in driving but also knowledgeable about the local area. If you're interested in sightseeing or want recommendations for places to visit in and around Mahabaleshwar, our drivers are happy to share valuable insights and make your trip more enjoyable."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our priority. We are committed to providing exceptional service and ensuring that your Pune to Mahabaleshwar trip is comfortable, safe and enjoyable. With a focus on quality service and customer care, we guarantee a hassle-free experience every time."
    }
  ]
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Pune to Mahabaleshwar?",
        answer: "You can easily book your Pune to Mahabaleshwar Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Pune to Mahabaleshwar route?",
        answer: "We offer a variety of vehicles for the Pune to Mahabaleshwar journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Pune to Mahabaleshwar inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Pune to Mahabaleshwar?",
        answer: "Yes, we offer one-way rental options for your Pune to Mahabaleshwar trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Pune to Mahabaleshwar trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Pune to Mahabaleshwar Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Pune to Mahabaleshwar Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Pune to Mahabaleshwar trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Pune to Mahabaleshwar?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Pune to Mahabaleshwar?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Pune to Mahabaleshwar trip was incredibly scenic and comfortable! The driver was professional and the vehicle was well-maintained.',
        name: 'Mr. Akash Gupta',
    },
    {
        text: 'I had an amazing experience with SHREE Tours & Travels. The drive from Pune to Mahabaleshwar was smooth and the driver made the journey enjoyable.',
        name: 'Miss. Neha Joshi',
    }
];






  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Cab",
  "description": "Book a reliable and affordable Pune to Mahabaleshwar cab service with S9 Travels. Enjoy a comfortable ride to Mahabaleshwar for a weekend getaway or temple visit, with private taxis available for one-way or round-trip travel. Choose from luxury and comfort options for your sightseeing tour or group travel from Pune to Mahabaleshwar.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1576"
  }
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune to Mahabaleshwar Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Cab from Pune to Mahabaleshwar with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune to Mahabaleshwar Taxi, Pune to Mahabaleshwar Cab Service, Pune to Mahabaleshwar One-Way Taxi, Pune to Mahabaleshwar Round Trip Cab, Affordable Pune to Mahabaleshwar Cab, Private Taxi for Mahabaleshwar from Pune, Mahabaleshwar Tour from Pune by Cab, Mahabaleshwar Cab Hire, Group Travel from Pune to Mahabaleshwar, Book Pune to Mahabaleshwar Car, Mahabaleshwar Cab Booking from Pune, Luxury Cab for Pune to Mahabaleshwar, Weekend Trip Pune to Mahabaleshwar, Mahabaleshwar Sightseeing Tour by Cab, Pune to Mahabaleshwar Comfort Taxi, Mahabaleshwar Temple Visit by Cab" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/4.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetomahabaleshwar;